import { amount, usd } from '../lib/format.js';

// Kostenvorschau: rechnet die Auswahl live gegen die Werte aus dem Server hoch.
export default function costPreview() {
  const form = document.querySelector('[data-estimate-form]');
  if (!form) return;

  const output = form.querySelector('[data-estimate-total]');
  const callsOut = form.querySelector('[data-estimate-calls]');
  if (!output) return;

  const rates = JSON.parse(form.dataset.estimateForm || '{}');
  const prompts = parseInt(form.dataset.prompts || '0', 10);
  const format = JSON.parse(form.dataset.amountFormat);

  function update() {
    const reps = Math.max(1, parseInt(form.querySelector('[name=repetitions]').value || '1', 10) || 1);
    let total = 0;
    let calls = 0;

    // Betrag je Provider, auch für nicht gewählte - er zeigt, was die
    // Auswahl kosten würde.
    form.querySelectorAll('[data-cost]').forEach(function (row) {
      const perCall = rates[row.dataset.cost];
      if (typeof perCall !== 'number') return;
      row.querySelector('[data-cost-total]').textContent = amount(perCall * prompts * reps, format);
      row.querySelector('[data-cost-calls]').textContent = String(prompts * reps);
    });

    form.querySelectorAll('input[name="providers[]"]:checked').forEach(function (box) {
      const perCall = rates[box.value];
      if (typeof perCall !== 'number') return;
      total += perCall * prompts * reps;
      calls += prompts * reps;
    });

    // Bewertungs-KI: höchstens ein Aufruf je Antwort der gewählten Provider.
    const judgeRow = form.querySelector('[data-judge-cost]');
    if (judgeRow) {
      const rate = parseFloat(judgeRow.dataset.rate) || 0;
      const box = form.querySelector('input[data-judge]');
      // Pauschaltarif: der Betrag bleibt "im Kontingent", nur die Zahl der Antworten wandert mit.
      if (judgeRow.dataset.flat !== '1') judgeRow.querySelector('[data-cost-total]').textContent = amount(rate * calls, format);
      judgeRow.querySelector('[data-cost-calls]').textContent = String(calls);
      if (box && box.checked && !box.disabled) total += rate * calls;
    }

    output.textContent = usd(total, format);
    if (callsOut) callsOut.textContent = String(calls);
  }

  form.addEventListener('change', update);
  form.addEventListener('input', update);
  update();
}
